import { BetaPill, Button, SingleColumnLayout, Tab, Tabs } from '@components'
import { PermissionSet, useBusinessContext, usePermission } from '@context'
import { useLocalStorage } from '@hooks'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaPlus } from 'react-icons/fa'
import styled from 'styled-components'
import { WorkflowSortMenu } from '../list/WorkflowSortMenu'
import { DEFAULT_WORKFLOW_SORT, WorkflowSortState } from '../list/workflowSortUtils'
import { AccountingMethodTab } from './AccountingMethodTab'
import { AccountingRulesTab } from './AccountingRulesTab'
import { WorkflowsTab } from './WorkflowsTab'

export const WorkflowsHub: React.FC = () => {
  const [t] = useTranslation()
  const { slug } = useBusinessContext()
  const canSeeWorkflows = usePermission(PermissionSet.ADMIN)
  const canSeeRules = usePermission(PermissionSet.BOOKKEEPING_ADMIN)
  const canSeeMethod = usePermission(PermissionSet.INVOICING_ADMIN)
  const [sort, setSort] = useLocalStorage<WorkflowSortState>(
    `${slug}.workflows.sort`,
    DEFAULT_WORKFLOW_SORT
  )
  const [createRuleRequest, setCreateRuleRequest] = useState(0)

  return (
    <SingleColumnLayout header={t('workflows.title')}>
      <HubScroll>
        <Tabs toolbar fillHeight>
          {canSeeWorkflows && (
            <Tab
              key="workflows"
              name={t('workflows.hub.tabs.workflows')}
              actions={<WorkflowSortMenu sort={sort} onSortChange={setSort} />}
            >
              <WorkflowsTab sort={sort} />
            </Tab>
          )}
          {canSeeRules && (
            <Tab
              key="rules"
              name={t('workflows.hub.tabs.rules')}
              actions={
                <>
                  <BetaPill label={t('general.beta.label')} tooltip={t('general.beta.tooltip')} />
                  <Button
                    onClick={() => setCreateRuleRequest(request => request + 1)}
                    intent="success"
                    icon={<FaPlus />}
                  >
                    {t('settings.automation.accountingRules.new')}
                  </Button>
                </>
              }
            >
              <AccountingRulesTab createRequest={createRuleRequest} />
            </Tab>
          )}
          {canSeeMethod && (
            <Tab key="accrual" name={t('workflows.hub.tabs.accountingMethod')}>
              <AccountingMethodTab />
            </Tab>
          )}
        </Tabs>
      </HubScroll>
    </SingleColumnLayout>
  )
}

const HubScroll = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`
